import { useForm } from "react-hook-form";
import { UpdatePasswordType } from "../types";
import { useNavigate } from "@tanstack/react-router";
import { zodResolver } from "@hookform/resolvers/zod";
import { updatePasswordSchema } from "../schemas";
import { useUpdatePasswordMutation } from "../api/mutations";
import { toast } from "sonner";
import { PasswordRequirement } from "~/types/auth";
import { useEffect, useState } from "react";

interface UseUpdateProps {
  token?: string;
}

export const useUpdate = ({ token }: UseUpdateProps = {}) => {
    const [passwordRequirements, setPasswordRequirements] = useState<PasswordRequirement>({
        minLength: false,
        hasUppercase: false,
        hasLowercase: false,
        hasNumber: false,
        hasSpecial: false,
    });
    const navigate = useNavigate();
    const { mutateAsync: updatePassword, isPending: isLoading } = useUpdatePasswordMutation();

    const form = useForm<UpdatePasswordType>({
        defaultValues: {
            password: "",
            confirmPassword: "",
        },
        resolver: zodResolver(updatePasswordSchema),
    })

    const password = form.watch("password");

    useEffect(() => {
        // Check password requirements
        setPasswordRequirements({
        minLength: password.length >= 8,
        hasUppercase: /[A-Z]/.test(password),
        hasLowercase: /[a-z]/.test(password),
        hasNumber: /[0-9]/.test(password),
        hasSpecial: /[^A-Za-z0-9]/.test(password),
        });
    }, [password]);



    // console.log(token);

    const onSubmit = async (data: UpdatePasswordType)=> {
        if (!token) {
            toast.error("No token provided for password update");
            return;
        }

        try {
            const response = await updatePassword({
                token: token,
                password: data.password,
            });

            if (response.success) {
                toast.success(response.message);
                navigate({ to: '/success/$type', params: { type: 'update' } });
            }
        } catch (error) {
            console.error("Error Updating User Password", error);
            toast.error("Failed to update password. Please try again.");
        }   
    }

    return { form, onSubmit, passwordRequirements, isLoading }
}

